import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
`
